import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { FilterBlock } from '../Filters/FilterBlock';
import { SourceFilter } from '../Filters/SourceFilter';
import { SeasonsFilter } from '../Filters/SeasonsFilter';
import { ParamsFilter } from '../Filters/ParamsFilter';
import { RatingFilter } from '../Filters/RatingFilter';
import { IconDismiss } from '../../../../../components/icons/IconDismiss';
import S from '../../../../stores';

const CLOSE_ANIMATION_DELAY = 200;

export interface FiltersMobileProps {}
export interface FiltersMobileState {
    closeAnimation: boolean;
}

interface StyledFiltersMobileProps
    extends FiltersMobileProps,
        JSSClassesProps<ComponentJSSClasses> {}

@observer
export class FiltersMobile extends React.Component<StyledFiltersMobileProps, FiltersMobileState> {
    constructor(props: StyledFiltersMobileProps) {
        super(props);
        this.state = {
            closeAnimation: false,
        };
    }

    onClickHandler = () => this.startCloseAnimationHandler();

    startCloseAnimationHandler = () => {
        this.setState({ closeAnimation: true });

        setTimeout(() => {
            this.setState({ closeAnimation: false });
            S?.hotelReviews.setMobileFiltersOpen(false);
        }, CLOSE_ANIMATION_DELAY);
    }

    render() {
        const { classes } = this.props;

        return (
            <div
                className={`${classes.container} ${
                    this.state.closeAnimation && classes.containerClosed
                }`}
            >
                <div className={classes.header}>
                    <h3 className={classes.title}>Фильтры</h3>
                    <button className={classes.closeButton} onClick={this.onClickHandler}>
                        <IconDismiss />
                    </button>
                </div>
                <FilterBlock title={'Параметры'}>
                    <ParamsFilter
                        reviewsAmount={S.hotelReviews.reviewsAmountToParamsFilters}
                    />
                </FilterBlock>
                <FilterBlock title={'Оценка в отзывах'}>
                    <RatingFilter />
                </FilterBlock>
                <FilterBlock title={'Источник отзывов'}>
                    <SourceFilter sources={S.hotelReviews.foundSources} />
                </FilterBlock>
                <FilterBlock title={'Сезон'}>
                    <SeasonsFilter
                        reviewsAmount={S.hotelReviews.reviewsOverview.amountBySeasons}
                    />
                </FilterBlock>
            </div>
        );
    }
}

export default FiltersMobile;
